import React from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { canonicalLabel, COLLECTIONPOINT_IMPORT_FIELDS } from './import-schema';

/** Πίνακας οδηγιών πεδίων εισαγωγής — εμφανίζεται στο PreImportModal */
export const ImportFieldHelp: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-4">
      <h6 className="mb-2 fw-semibold">{t('Οδηγίες στηλών Excel')}</h6>
      <p className="text-muted small mb-2">
        {t(
          'Η ταυτοποίηση γίνεται μόνο με την επωνυμία. Αν υπάρχει σημείο με την ίδια επωνυμία ενημερώνεται· αλλιώς καταχωρείται νέο. Κενά κελιά σε ενημέρωση δεν αλλάζουν την υπάρχουσα τιμή.',
        )}
      </p>
      <p className="text-muted small mb-2">
        {t(
          'Μετά την εισαγωγή προστίθενται αυτόματα οι στήλες «Κατάσταση Εισαγωγής» και «Αποτέλεσμα Εισαγωγής».',
        )}
      </p>
      <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
        <Table bordered size="sm" className="mb-0 bg-white" style={{ fontSize: '0.82rem' }}>
          <thead className="table-light">
            <tr>
              <th>{t('Στήλη')}</th>
              <th className="text-center" style={{ width: '90px' }}>
                {t('Υποχρ.')}
              </th>
              <th>{t('Περιγραφή')}</th>
              <th>{t('Παράδειγμα')}</th>
            </tr>
          </thead>
          <tbody>
            {COLLECTIONPOINT_IMPORT_FIELDS.map((def) => (
              <tr key={def.field}>
                <td>
                  <div className="fw-medium">{canonicalLabel(def)}</div>
                  {def.labels.length > 1 && (
                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                      {def.labels.slice(1).join(', ')}
                    </div>
                  )}
                </td>
                <td className="text-center">{def.required ? t('Ναι') : t('Όχι')}</td>
                <td>
                  {def.description || <span className="text-muted">—</span>}
                  {def.notes && (
                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                      {def.notes}
                    </div>
                  )}
                </td>
                <td>{def.example || <span className="text-muted">—</span>}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};
